// redux/actions/TRIBUNAL/types.js
export const FETCH_TRIBUNAL_SUCCESS = "FETCH_TRIBUNAL_SUCCESS";
export const FETCH_TRIBUNAL_FAILURE = "FETCH_TRIBUNAL_FAILURE";
export const FETCH_AUDIT_LOG_TRIBUNAL_SUCCESS = "FETCH_AUDIT_LOG_TRIBUNAL_SUCCESS";
export const FETCH_AUDIT_LOG_TRIBUNAL_FAILURE = "FETCH_AUDIT_LOG_TRIBUNAL_FAILURE";
export const FETCH_TRIBUNAL_ETAPAS_SUCCESS = "FETCH_TRIBUNAL_ETAPAS_SUCCESS";
export const FETCH_TRIBUNAL_ETAPAS_FAILURE = "FETCH_TRIBUNAL_ETAPAS_FAILURE";
export const FETCH_TRIBUNAL_DETALLES_FAILURE = "FETCH_TRIBUNAL_DETALLES_FAILURE";
export const FETCH_TRIBUNAL_DETALLES_SUCCESS = "FETCH_TRIBUNAL_DETALLES_SUCCESS";